import { gql } from '@apollo/client'
import { reviewFragment } from 'modules/reviews/fragments.graphql'

export const reviewQuery = gql`
  ${reviewFragment}
  query Review($id: ID!) {
    review(id: $id) {
      ...ReviewFields
    }
  }
`
